import { Role } from '@/models/role';

export const ROUTE_ROLES = {
  DASHBOARD: {
    roles: [Role.Admin],
  },
  CASH_MANAGEMENT: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.ResponsibleWarehouse,
      Role.ResponsibleGarage,
      Role.Sellers,
      Role.Backoffice,
      Role.Warehouse,
      Role.Garage,
      Role.Accounting,
    ],
  },
  CASH_MOVEMENTS_ANALYSIS: {
    roles: [Role.Admin, Role.Accounting],
  },
  PRACTICES: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.ResponsibleSubagents,
      Role.ResponsibleGarage,
      Role.Sellers,
      Role.Subagents,
      Role.Accounting,
      Role.Backoffice,
      Role.RentManagement,
    ],
  },
  BUSINESS_MACHINES: {
    roles: [
      Role.Admin,
      Role.Accounting,
      Role.Backoffice,
      Role.ResponsibleSellers,
      Role.RentManagement,
    ],
  },
  DELIVERY_CARDBOARD: {
    roles: [Role.Admin, Role.Accounting, Role.Backoffice, Role.ResponsibleSellers],
  },
  BRAND_GOALS: {
    roles: [Role.Admin, Role.Accounting, Role.Backoffice, Role.ResponsibleSellers],
  },
  RENTAL_PRACTICES: {
    roles: [
      Role.Admin,
      Role.Accounting,
      Role.ResponsibleSellers,
      Role.Garage,
      Role.ResponsibleGarage,
      Role.RentManagement,
    ],
  },
  INSURANCES: {
    roles: [Role.Admin, Role.Accounting],
  },
  VEHICLE_REGISTRY: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.Sellers,
      Role.Backoffice,
      Role.Accounting,
      Role.Warehouse,
      Role.Garage,
      Role.ResponsibleWarehouse,
      Role.ResponsibleGarage,
      Role.TableManager,
      Role.Import,
      Role.CemManagement,
      Role.RentManagement,
    ],
  },
  CUSTOMERS: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.Sellers,
      Role.Backoffice,
      Role.Accounting,
      Role.Warehouse,
      Role.Garage,
      Role.ResponsibleWarehouse,
      Role.ResponsibleGarage,
      Role.TableManager,
      Role.Import,
      Role.CemManagement,
      Role.RentManagement,
    ],
  },
  MMSS: {
    roles: [Role.Admin, Role.ResponsibleSellers, Role.Accounting],
  },
  USED_VEHICLE: {
    roles: [Role.Admin, Role.ResponsibleSellers, Role.Sellers, Role.Accounting, Role.Backoffice],
  },
  STOCK: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.Sellers,
      Role.Accounting,
      Role.Backoffice,
      Role.Subagents,
      Role.ResponsibleSubagents,
    ],
  },
  IMPORTS: {
    roles: [Role.Admin, Role.Import],
  },
  TABLES: {
    roles: [Role.Admin, Role.TableManager, Role.Accounting],
  },
  ADMIN: {
    roles: [Role.Admin],
  },
  MENU_BI: {
    roles: [
      Role.Admin,
      Role.ResponsibleSellers,
      Role.ResponsibleWarehouse,
      Role.ResponsibleGarage,
      Role.Backoffice,
      Role.Accounting,
      Role.Warehouse,
    ],
  },
  GESTIONE_CEM: {
    roles: [Role.Admin, Role.CemManagement],
  },
  TEST_DRIVE: {
    roles: [Role.Admin, Role.TestDriveManager, Role.ResponsibleSellers, Role.Sellers],
  },
  GESTORE_UTENTI: {
    roles: [Role.Admin, Role.UserManager],
  },
};
